import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { getTitleTooltipId } from '../htmlElements/htmlElementsGetter';
import { ToolTip } from '../../../common/components/toolTip/toolTip';
import { TOOLTIP_POSITIONS } from '../../../common/components/toolTip/toolTip.contants';
import { useStyles } from '../../../common/hooks/useStyles';
import { getTitleStyleObject } from './title.style';
import { isDesktopMode, isEmpty } from '../../../common/utils/utils';
import { playerDataSelector } from '../../../common/store/selectors/playerData.selector';
import { videoDataSelector } from '../../../common/store/selectors/videoData.selector';
import { TitleText } from './titleText';
import { anchorDataSelector } from '../../../common/store/selectors/anchorData.selector';
import { anchorOptionsSelector } from '../../../common/store/selectors/anchorOptions.selector';
import { splitViewSelector } from '../../../common/store/selectors/splitView.selector';

export const Title: FunctionComponent = () => {
  const playerMode = useSelector(playerDataSelector.playerMode);
  const title = useSelector(videoDataSelector.title);
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqueId);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const anchorStatus = useSelector(anchorDataSelector.anchorStatus);
  const canClose = useSelector(anchorOptionsSelector.canClose);
  const splitViewRatio = useSelector(splitViewSelector.splitViewRatio);

  const closableAnchor = anchorStatus === 'active' && canClose;
  const showCloseBar = closableAnchor && isEmpty(splitViewRatio);
  const desktopMode = isDesktopMode(playerMode);

  const styles = useStyles(getTitleStyleObject, [playerSize]);
  const { containerStyle, titleStyle } = styles;

  return (
    <div style={containerStyle}>
      {desktopMode && !showCloseBar
        ? (
          <ToolTip content={title} position={TOOLTIP_POSITIONS.BOTTOM} id={getTitleTooltipId(playerUniqueId)}>
            <TitleText titleStyle={titleStyle} />
          </ToolTip>
        )
        : <TitleText titleStyle={titleStyle} />}
    </div>
  );
};
